module.exports = __webpack_public_path__ + "img/3d.b8e23a11.svg";